var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #222939 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m26.4 19.2l-1.4-2.1c-0.3-0.4-0.6-1.3-0.6-1.8v-3.1c0-2.8-1.9-5.3-4.8-6.5-0.7-1.1-2.1-1.8-3.7-1.8-1.5 0-2.9 0.7-3.7 1.9-2.7 1.2-4.7 3.6-4.7 6.4v3.1c0 0.5-0.2 1.4-0.5 1.8l-1.5 2.1c-0.5 0.8-0.7 1.7-0.3 2.5 0.3 0.8 1.1 1.5 2.2 1.8 2.8 0.8 5.7 1.2 8.6 1.2 2.9 0 5.8-0.4 8.6-1.2 1-0.3 1.7-0.9 2.1-1.8 0.4-0.8 0.3-1.8-0.3-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m20.3 25.8c-0.6 1.9-2.3 3.3-4.3 3.3-1.3 0-2.5-0.6-3.3-1.5-0.5-0.5-0.9-1.2-1.1-1.8q0.3 0 0.6 0.1 0.5 0 1.1 0.1 1.3 0.1 2.7 0.1 1.3 0 2.6-0.1 0.5-0.1 1-0.1 0.4-0.1 0.7-0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify1);
export default __webpack_public_path__ + "static/media/notify-1.7ca4e9b88e0913140dd418539b8ae9a5.svg";
export { ForwardRef as ReactComponent };